/* global Glide */
(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.slider = {

    initialized: false,

    attach: function (context) {
      if(!this.initialized){
        this.initialized = true;
        this.init(context);
      }
    },

    init: function (context) {
      if(context.querySelectorAll('.js-hero .hero-testimonials').length == 1) {
        var options = {
          type: 'carousel',
          animationDuration: 300,
          perView: 1,
          animationTimingFunc: 'ease-in-out',
          autoplay: 8000
        };
      }else {
        var options = {
          type: 'carousel',
          animationDuration: 300,
          perView: 1,
          animationTimingFunc: 'ease-in-out'
        };
      }
      let carousels = context.querySelectorAll('.js-hero .glide');
      Object.values(carousels).map(function (carousel) {
        let glide = new Glide(carousel, options);
        glide.mount();
        let rightArrow = carousel.querySelector('.glide__arrow--right');
        let leftArrow = carousel.querySelector('.glide__arrow--left');

        function goRight(e) {
          e.preventDefault();
          glide.go('>');
        }

        function goLeft(e) {
          e.preventDefault();
          glide.go('<');
        }

        rightArrow.addEventListener('click', goRight);
        leftArrow.addEventListener('click', goLeft);


        let overlap = context.querySelector('.row__top-overlap');
        if (overlap) {
          carousel.classList.add('basic-overlap');
        }
      });

    }
  };
}(jQuery, Drupal));